import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDimensionUnit } from '@store/overviewDashboard/base/actions';
import { kpiMetricSelector } from '@store/overviewDashboard/base/selectors';
import UnitToggle from '@components/common/UnitToggle';
import { DISABLE_UNIT_TOGGLE_METRICS } from '@src/utils/kpi';
import { HeaderFlexWrap, TitleFlexWrap, DisabledUnitToggle, UnitToggleWrapper } from '../styled';
import KpiMetricsDropdown from './KpiMetricsDropdown';
import { MetricTitle } from '../../styled';

const DimensionHeader = ({ widgetIndex, unit }) => {
  const dispatch = useDispatch();
  const selectedKPIMetric = useSelector(kpiMetricSelector);

  const onUnitChange = (value) => {
    dispatch(setDimensionUnit(widgetIndex, value));
  };

  const getUnitToggle = () => {
    if (DISABLE_UNIT_TOGGLE_METRICS.includes(selectedKPIMetric)) {
      return (
        <DisabledUnitToggle>
          <UnitToggle selectedUnit={unit} onChange={onUnitChange} totalDisabled={true} />
        </DisabledUnitToggle>
      );
    }
    return (
      <UnitToggleWrapper>
        <UnitToggle selectedUnit={unit} onChange={onUnitChange} totalDisabled={true} />
      </UnitToggleWrapper>
    );
  };

  return (
    <HeaderFlexWrap>
      <TitleFlexWrap>
        <MetricTitle>Dimensions by</MetricTitle>
        <KpiMetricsDropdown />
      </TitleFlexWrap>
      {getUnitToggle()}
    </HeaderFlexWrap>
  );
};

export default DimensionHeader;
